import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    codeView: {
        "& .mantine-Input-input": {
            backgroundColor: theme.black,
            color: theme.white,
            borderRadius: 0,
            border: "none",
            "&:focus": {
                border: "none",
                boxShadow: "none",
            },
            "&:active": {
                border: "none",
                boxShadow: "none",
            },
        },
    },
}))
